/*
 * @Description  : 
 * @Author       : wuxuebing
 * @Date         : 2025-02-24 17:37:27
 * @LastEditors  : wuxuebing
 * @LastEditTime : 2025-03-25 11:37:37
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\website.js
 */
// 网站维护 接口集合
import request from '../request.js'

// 列表展示,数据查询 --- 徐仲阳
export const getListData = function (data) {
    return request({
		// baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
        url: 'webSystem/getListForBannerPage',
        method: 'post',
        data
    })
}

// 添加修改配置 --- 徐仲阳
export const getSelectData = function (data) {
    return request({
		// baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
        url: 'webSystem/getListByDifferentConditions',
        method: 'post',
        data
    })
}

// banner应用项目新增/修改 --- 徐仲阳
export const changeState = function (data) {
    return request({
		// baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
        url: 'webSystem/insertOrUpdateWebSystem',
        method: 'post',
        data
    })
}

// banner应用项目删除 -- 徐仲阳
export const deleItem = function (data) {
    return request({
		// baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
        url: 'webSystem/deleteSystem',
        method: 'post',
        data
    })
}

// 变更banner状态 -- 徐仲阳
export const updateBanner = function (data) {
    return request({
        url: '/webSystem/updateBanner',
        method: 'post',
        data
    })
}

// 新增/修改banner -- 徐仲阳
export const insertOrUpdateBanner = function (data) {
    return request({
        url: '/webSystem/insertOrUpdateBanner',
        method: 'post',
        data
    })
}


//获取生效网站banner列表
export const getWebBannerEffectiveList = function (data) {
    return request({
		baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
        url: 'webBanner/getWebBannerEffectiveList',
        method: 'post',
        data
    })
}
//获取网站banner列表 -- 徐仲阳
export const getWebBannerList = function (data) {
    return request({

        url: 'webSystem/getWebBannerList',
        method: 'post',
        data
    })
}
//上传网站banner
export const addWebBanner = function (data) {
    return request({
		baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
        url: 'webBanner/addWebBanner',
        method: 'post',
        data
    })
}
//保存设置效果
export const takeEffectWebBanner = function (data) {
    return request({
		baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
        url: 'webBanner/takeEffectWebBanner',
        method: 'post',
        data
    })
}